import { Route, Routes } from 'react-router-dom';
import SoftpayCallbackAndroid from '../pages/Softpay/SoftpayCallbackAndroid';

const PublicRoute = () => (
  <Routes>
    <Route path="softpay-android" element={<SoftpayCallbackAndroid />} />
  </Routes>
);
export default PublicRoute;
